import { Gem, LogIn, Plus } from 'lucide-react'
import { Link } from 'react-router-dom'
import logo from '@/assets/logo.png'
import { UserAvatarMenu } from '@/platform/account/UserAvatarMenu'
import { WorkspaceSwitcher } from '@/platform/workspace-catalog/ui/WorkspaceSwitcher'
import type { WalletSummary } from '@/platform/wallet/model/types'

interface AppHeaderProps {
  authenticated: boolean
  logoutBusy: boolean
  wallet: WalletSummary | null
  walletLoading: boolean
  onDeposit: () => void
  onLogin: () => void
  onLogout: () => void
}

export function AppHeader({ authenticated, logoutBusy, wallet, walletLoading, onDeposit, onLogin, onLogout }: AppHeaderProps) {
  return <header className="sticky top-0 z-40 border-b border-slate-100 bg-white px-3 py-2.5 sm:px-6">
    <div className="mx-auto flex max-w-4xl items-center justify-between gap-2 sm:gap-3">
      <Link to="/" className="flex shrink-0 items-center gap-2 text-left"><img src={logo} alt="Học Nhé" className="h-8 w-8 object-contain" /><span className="hidden flex-col min-[390px]:flex"><span className="text-[15px] font-black leading-none tracking-tight text-[#0068FF]">Học Nhé</span><span className="mt-0.5 text-[9px] font-extrabold uppercase tracking-wider text-[#E65F00]">Học cùng nhau</span></span></Link>
      <WorkspaceSwitcher />
      <div className="flex items-center gap-2 sm:gap-3">{authenticated ? <>
        <button type="button" onClick={onDeposit} className="flex h-8 items-center overflow-hidden rounded-xl border border-[#E65F00] bg-white shadow-sm transition-colors hover:bg-orange-50" title="Xem và nạp Credit" aria-label="Xem và nạp Credit">
          <span className="flex h-full items-center gap-1.5 bg-slate-50/50 px-2 sm:px-3">
            <Gem className="h-3.5 w-3.5 text-[#E65F00]" />
            <span className="font-mono text-xs font-black text-[#E65F00]">{walletLoading && !wallet ? '...' : (wallet?.credit_balance ?? 0).toLocaleString('vi-VN')}</span>
          </span>
          <span className="h-full w-px bg-orange-200" />
          <span className="grid h-full w-8 place-items-center text-[#0068FF]">
            <Plus className="h-3.5 w-3.5 stroke-[3]" />
          </span>
        </button>
        <UserAvatarMenu busy={logoutBusy} onLogout={onLogout} />
      </> : <button type="button" onClick={onLogin} className="inline-flex min-h-9 items-center gap-1.5 rounded-xl border border-[#0068FF] px-3 text-xs font-bold text-[#0068FF]"><LogIn className="h-3.5 w-3.5" /><span className="hidden sm:inline">Đăng nhập</span></button>}</div>
    </div>
  </header>
}
